<div class="save-container">
  <div class="save-errors">
    @if (!isValid) {
      <div>
        @for (error of errors; track error) {
          <div class="save-error">{{ error }}</div>
        }
      </div>
    }
  </div>
  <div class="save-button">
    <rask-save-button (click)="save()" [disabled]="isDisabled()">Spara</rask-save-button>
  </div>
</div>

